export default function ThreeJs() {
  return (
    <div className="threejs-page">
      <header className="portfolio-header">
        <p className="portfolio-kicker">WebGL &amp; React</p>
        <h1>Plan 3D avec Three.js</h1>
        <p>
          Salon d’exposition interactif en 3D — navigation libre, stands
          cliquables et ambiance réaliste dans le navigateur.
        </p>
      </header>

      <div className="threejs-grid">
        <div className="threejs-media">
          <div className="threejs-frame">
            <iframe
              title="Aperçu 3D Treeosk"
              src="https://app.mytreeosk.com/project/b3e386ed-a787-4dfe-b102-72119a0ef2e4/preview/page/182259e1-8720-4f7e-b860-e5ac6931a4bc"
            />
          </div>
          <img
            className="threejs-shot"
            alt="Exemple de kiosque"
            src="./assets/exemple kiosk.jpeg"
          />
        </div>

        <div className="threejs-copy">
          <p>
            Découvrez un espace immersif conçu avec Three.js et React : les
            visiteurs se déplacent librement parmi stands, produits et
            présentations en temps réel.
          </p>
          <ul>
            <li>Navigation fluide avec une caméra intuitive</li>
            <li>Stands interactifs avec infos détaillées au clic</li>
            <li>Éclairage dynamique et ombres soignées</li>
            <li>Optimisation WebGL pour une expérience fluide</li>
          </ul>
          <a href="mailto:julien.j.1999@hotmail.com">
            Contactez-moi : julien.j.1999@hotmail.com
          </a>
        </div>
      </div>
    </div>
  );
}
